export default "__VITE_ASSET__CfKnLXmj__"